import React, { Fragment } from 'react';
import { Container } from 'reactstrap';
import { PageDetailsPanel } from '../../controls/PageDetails/PageDetailsPanel.jsx';
import { ContactUs } from '../../controls/People/ContactUs.jsx';
import { ArcaComponent } from '../ArcaComponent.js';

export class PageDetails extends ArcaComponent  {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        const { pageListDetails } = this.props;

        return (

            !pageListDetails
                ? <Fragment>
                    Page is loading ...
                </Fragment>

                : <Fragment>
                    <Container fluid className='NoPadding'>

                        {pageListDetails?.map((details, key) =>
                            <div className='rounded px-3 px-sm-4 py-3 py-sm-5 pagePanel article' key={key} >
                                <PageDetailsPanel details={details} index={key + 1} />
                            </div>
                        )}

                        <ContactUs />
                    </Container>
                </Fragment>
        );
    }
}
